import './scss/index.scss';
import BlockPlaceholder from './js/block-placeholder';

export {
    BlockPlaceholder
};
